var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('brand-logo',{staticClass:"flex items-center justify-start"}),(!_vm.$configs.inIframe)?_c('div',{staticClass:"flex justify-end"},[_c('nav-user-dropdown')],1):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }